// extracted by mini-css-extract-plugin
module.exports = {"topRightButtons":"styles_topRightButtons__qnuMq","terrainInstructionsContainer":"styles_terrainInstructionsContainer__mqkvc"};